// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__b-V5m","title":"ClientCherryInfo_title__164jm","itemText":"ClientCherryInfo_itemText__1jN8u"};